import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import useUserCapabilities from '../utils/useUserCapabilities';
import {  useSelector } from 'react-redux';

const ProtectedRoute = ({ component: Component, requiredResource, requiredCapability, requiredRoles, ...rest }) => {
  const { hasResource, hasCapability, isLoading } = useUserCapabilities();
  const user = useSelector(state => state.auth.user);
  const roleName = user.override ? user.override.name : user.role.name;

  if (isLoading) {
    return <div>Loading...</div>; // Loading indicator
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        const hasRequiredResource = requiredResource ? hasResource(requiredResource) : true;
        const hasRequiredCapability = requiredCapability ? hasCapability(requiredCapability) : true;
        const hasRequiredRole = requiredRoles ? requiredRoles.includes(roleName) : true;

        return hasRequiredResource && hasRequiredCapability && hasRequiredRole ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        );
      }}
    />
  );
};

export default ProtectedRoute;
